import { useEffect } from 'react';
import { eventManager } from 'core/event/eventManager';
import { AppEvents } from 'core/event/constants';

/**
 * Subscribe to an event and unsubscribe when the component unmounts
 * or when the callback identity changes
 *
 * Please call this at the top level to avoid duplicate subscription and
 * `callback` must be memoized properly
 */
export const useEventSubscription = ({
  callback,
  eventName,
}: {
  callback: NonNullable<Parameters<EventTarget['addEventListener']>[1]>;
  eventName: AppEvents;
}) => {
  useEffect(() => {
    eventManager.listen({ eventName, callback });
    return () => eventManager.stopListen({ eventName, callback });
  }, [callback, eventName]);
};
